import { useState } from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "./../../../helpers/SiteTitle/SiteTitle";
import ImageModal from "../../../helpers/ImageModal/ImageModal";
import { base_url } from "../../../services/configServices/config";

const GalleryPublic = () => {
  const image = useSelector((state) => state.meta?.image);
  const setting = useSelector((state) => state.meta?.setting);

  const [info, setInfo] = useState({});

  return (
    <>
      <SiteTitle title="گالری تصاویر" />
      {/* Section Started Inner */}
      <section className="section kf-started-inner">
        <div
          className="kf-parallax-bg"
          style={{
            backgroundImage: `url(${base_url + image?.galleryBanner})`,
          }}
        />
        <div className="container">
          <h1
            className="kf-h-title text-anim-1 scroll-animate align-center"
            data-animate="active"
          >
            گالری تصاویر {setting?.title}
          </h1>
        </div>
      </section>
      {/* Section Gallery */}
      <section className="section kf-gallery">
        <div className="container">
          <div className="kf-titles align-center">
            <div
              className="kf-subtitle element-anim-1 scroll-animate"
              data-animate="active"
            >
              تصاویر کافه
            </div>
            <h3
              className="kf-title element-anim-1 scroll-animate"
              data-animate="active"
            >
              تصاویر منتخب کافه {setting?.title}
            </h3>
          </div>
          <div className="kf-gallery-items row">
            {image?.gallery?.map((item, index) => (
              <div
                key={index}
                className="kf-gallery-col col-xs-12 col-sm-12 col-md-6 col-lg-4 fast-food"
              >
                <div
                  className="kf-gallery-item element-anim-1 scroll-animate"
                  data-animate="active"
                >
                  <div className="image kf-image-hover">
                    <img
                      src={base_url + item}
                      alt={setting?.title}
                      onClick={() => setInfo(item)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ImageModal
        isHeader={false}
        show={!isEmpty(info)}
        onHide={() => setInfo({})}
        title={info.title}
      >
        <img
          src={base_url + info.image}
          alt={info.title}
          style={{ height: "100%", width: "100%" }}
        />
      </ImageModal>
    </>
  );
};

export default GalleryPublic;
